<template>
  <v-container fluid class="pa-0 ma-0" style="min-height: calc(100vh - 125px)">
    <v-overlay :value="loaderOverlay" :absolute="true">
      <v-row justify="center">
        <v-progress-circular indeterminate size="120"></v-progress-circular>
      </v-row>
    </v-overlay>
    <v-card class="w-100 d-flex flex-column" style="min-height: calc(100vh - 125px)">
      <v-card-title class="py-0">
        <v-row no-gutters style="max-width: 100%">
          <v-icon class="m-2 pt-2">mdi-calendar-clock</v-icon>
          <h3 class="ml-2 mt-2">{{ $t("timeReport") }}</h3>
        </v-row>
      </v-card-title>
      <v-card-text style="min-width: 0">
        <v-row class="pt-8" justify="center">
          <v-col cols="12">
            <v-row justify="center">
              <v-col cols="12" md="3">
                <v-select v-model="selectedReportType" :items="reportTypes" :label="$t('reportType')" color="primary" dense />
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete v-model="selectedTeam" :disabled="selectAllEmployees" :items="teams" :label="$t('teams')" color="primary" dense />
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="selectedEmployees"
                  :items="employees"
                  :disabled="selectAllEmployees"
                  item-text="name"
                  :label="$t('employees')"
                  multiple
                  return-object
                  chips
                  small-chips
                  color="primary"
                  dense
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-if="data.index < 5"
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="removeSelectedEmployee(data.item)"
                      >{{ data.item.name }}</v-chip
                    >
                    <span v-if="data.index === 5"> ... </span>
                  </template>
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                      <v-list-item-subtitle>{{ setTeamsForAutocomplete(data.item.teams) }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox v-model="selectAllEmployees" :label="$t('selectAllEmployees')" dense hide-details class="mt-2 pt-0" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row v-if="selectedReportType == $t('monthly')" justify="center">
          <v-col cols="12" md="4" lg="3" class="d-flex justify-center">
            <v-date-picker v-model="date" type="month" full-width :first-day-of-week="1" color="green lighten-1" />
          </v-col>
        </v-row>

        <v-row v-else justify="center">
          <v-col cols="12" md="4" lg="3">
            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="fromDate" :label="$t('from')" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" />
              </template>
              <v-date-picker v-model="fromDate" :max="toDate || today" show-current="false" :first-day-of-week="1" color="primary" />
            </v-menu>
            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="toDate" :label="$t('until')" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" />
              </template>
              <v-date-picker v-model="toDate" :min="fromDate" :max="today" show-current="false" :first-day-of-week="1" color="green lighten-1" />
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text class="pt-0 mt-auto">
        <v-row justify="end">
          <v-col cols="12" class="d-flex justify-end">
            <v-btn color="primary" class="font-weight-medium mt-3" @click="ShowTimeReport = true">
              {{ $t("request") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <MonthlyTimeReport
      v-if="ShowTimeReport"
      :items="this.selectedEmployees"
      :date="date"
      :fromDate="fromDate"
      :toDate="toDate"
      :isTimespan="selectedReportType != $t('monthly')"
      @close="
        ShowTimeReport = false;
        monthlyHistories = [];
      "
    />
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import MonthlyTimeReport from "./WorktimeAccount/MonthlyTimeReport";

export default {
  name: "TimeReports",
  route: "TimeReports",
  components: {
    MonthlyTimeReport
  },
  data: () => ({
    ShowTimeReport: false,
    loaderOverlay: false,
    selectAllEmployees: false,
    selectedReportType: null,
    reportTypes: [],
    employees: [],
    allEmployees: [],
    today: moment().format("YYYY-MM-DD"),
    date: moment().format("YYYY-MM-DD"),
    fromDate: moment().format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
    selectedEmployees: [],
    monthlyHistories: [],
    selectedTeam: null
  }),
  mounted() {
    this.selectedReportType = this.$t("monthly");
    this.reportTypes = [this.$t("monthly"), this.$t("timePeriod")];
  },
  async created() {
    this.loaderOverlay = true;
    await this.initialize();
    this.loaderOverlay = false;
  },
  computed: {
    ...mapGetters({
      teams: "users/teams"
    })
  },
  watch: {
    selectedTeam() {
      let filter = this.selectedTeam;
      if (this.selectedTeam != this.$t("all")) {
        this.employees = this.allEmployees.filter((employee) => employee.teams.some((team) => team.Team == filter));
      } else this.employees = [...this.allEmployees];

      if (this.selectedEmployees.length != 0) {
        let teamUsers = this.employees.filter((employee) => employee.teams.some((team) => team.Team == filter));
        let currentSelectedUser = this.selectedEmployees;
        this.selectedEmployees = [];
        for (let user of teamUsers) {
          this.selectedEmployees.push(currentSelectedUser.find((item) => item.SAPEmpID == user.SAPEmpID));
        }
      }
    },
    selectAllEmployees(val) {
      if (val) {
        this.selectedEmployees = [...this.employees];
      } else {
        this.selectedEmployees = [];
      }
    }
  },
  methods: {
    async initialize() {
      await this.getUserList();
      await this.getTeams();
    },
    async getUserList() {
      await this.$store.dispatch("users/getEmployees").then(() => {
        this.allEmployees = this.$store.getters["users/employeeList"];
      });
    },
    setTeamsForAutocomplete(teams) {
      let teamsName = [];
      for (let team of teams) {
        teamsName.push(team.Team);
      }
      return teamsName.join(", ");
    },
    removeSelectedEmployee(item) {
      let index = this.selectedEmployees
        .map((employee) => {
          return employee.SAPEmpID;
        })
        .indexOf(item.SAPEmpID);
      if (index >= 0) this.selectedEmployees.splice(index, 1);
    },

    async getTeams() {
      await this.$store
        .dispatch("users/getTeams")
        .then(() => {
          this.selectedTeam = this.teams[0];
        })
        .catch((err) => {
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", err.response.data, "bottom", "right");
          }
        });
    },

    isValidFromDate(date) {
      return !moment(date, "YYYY-MM").isAfter(moment());
    },

    isValidToDate(date) {
      const dateMoment = moment(date, "YYYY-MM");
      return !(dateMoment.isBefore(moment(this.fromDate)) || dateMoment.isAfter(moment()));
    }
  }
};
</script>
